import { render, staticRenderFns } from "./tit-wrap-primary.vue?vue&type=template&id=b7d15d76&scoped=true"
import script from "./tit-wrap-primary.vue?vue&type=script&lang=js"
export * from "./tit-wrap-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d15d76",
  null
  
)

export default component.exports